// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

import browser from 'browser-detect' 
import { platform } from 'os';
import users from '../users/index_backup' 
export default{
  state: { 
    appName:'Masoathu', 
    loadedPages:[],
    connectionState:false,

    QUESTION_CHECKLISTS:null,
    QUESTION_RESPONSE:null,
    QUESTION_STAGES:null,
    QUESTION_TYPES:null,
    QUESTION_CATEGORIES:null,
    QUESTION_TIMELINE:null,

    candidates:null, 
    parties:null, 
    Regions:null, 
    districts:null,
    constituencies: null,
    wards: null, 
    centres:null,  


    SUBMITTED_RESULTS_LEVEL:null,
    DISTRICT_RESULTS:null,
    DISTRICT_RESULTS_DETAILS:null,
    CONSTITUENCY_RESULTS:null,
    CONSTITUENY_RESULTS_DETAILS:null,
    WARD_RESULTS:null,
    WARD_RESULTS_DETAILS:null,
    CENTRE_RESULTS:null,
    CENTRE_RESULTS_DETAILS:null,

    gender:["male","female"],
    candidateTypes:["presindetial"],
    submitLevel:["district","constituency","ward","centre"],

    PERMISSIONS:{
      pages:[
        {id:1,name:'dashboard',name2:'Dashboard Panel',allow:false},
        {id:2,name:'Dashboard Plus',name2:'Other Dashboards',allow:false},
        {id:3,name:'checklist',allow:false},
        {id:4,name:'question list',allow:false},
        {id:5,name:'question configurations',allow:false}, 
        {id:6,name:'reports',allow:false},
        {id:7,name:'observer reports',allow:false}, 
        {id:7,name:'Intervention Desk',allow:false}, 
        {id:7,name:'SMS',allow:false}, 
        {id:8,name:'Results',allow:false}, 
        {id:9,name:'Graph Results',allow:false}, 
        {id:9.1,name:'Map Results',allow:false}, 
        {id:10,name:'Manage Results',allow:false}, 
        {id:11,name:'Settings',allow:false}, 
        {id:12,name:'My Profile',allow:false}, 
        {id:13,name:'Users',allow:false}, 
        {id:14,name:'Candidates',allow:false}, 
        {id:15,name:'Parties',allow:false},
        {id:16,name:'Observers',allow:false}, 
        {id:17,name:'Regions',allow:false},   
        {id:18,name:'Districts',allow:false}, 
        {id:19,name:'Constituencies',allow:false}, 
        {id:20,name:'Wards',allow:false}, 
        {id:21,name:'Centres',allow:false}, 
        {id:22,name:'Permissions',allow:false},   
      ],
      read:[
        {id:1,name:'results',allow:false},
        {id:2,name:'responses',allow:false},
        {id:3,name:'checklist',allow:false},
        {id:4,name:'users',allow:false},
        {id:5,name:'user groups',allow:false},
        {id:6,name:'observers',allow:false},
        {id:7,name:'candidates',allow:false},
        {id:8,name:'regions',allow:false},
        {id:9,name:'districts',allow:false},
        {id:10,name:'constituencies',allow:false},
        {id:11,name:'wards',allow:false},
        {id:12,name:'centres',allow:false},
        {id:13,name:'parties',allow:false},
      ],
      write:[
        {id:1,name:'results',allow:false},
        {id:2,name:'responses',allow:false},
        {id:3,name:'checklist',allow:false},
        {id:4,name:'users',allow:false},
        {id:5,name:'user groups',allow:false},
        {id:6,name:'observers',allow:false},
        {id:7,name:'candidates',allow:false},
        {id:8,name:'regions',allow:false},
        {id:9,name:'districts',allow:false},
        {id:10,name:'constituencies',allow:false},
        {id:11,name:'wards',allow:false},
        {id:12,name:'centres',allow:false},
        {id:13,name:'parties',allow:false},
      ],
      edit:[
        {id:1,name:'results',allow:false},
        {id:2,name:'responses',allow:false},
        {id:3,name:'checklist',allow:false},
        {id:4,name:'users',allow:false},
        {id:5,name:'user groups',allow:false},
        {id:6,name:'observers',allow:false},
        {id:7,name:'candidates',allow:false},
        {id:8,name:'regions',allow:false},
        {id:9,name:'districts',allow:false},
        {id:10,name:'constituencies',allow:false},
        {id:11,name:'wards',allow:false},
        {id:12,name:'centres',allow:false},
        {id:13,name:'parties',allow:false},
      ],
      delete:[
        {id:1,name:'results',allow:false},
        {id:2,name:'responses',allow:false},
        {id:3,name:'checklist',allow:false},
        {id:4,name:'users',allow:false},
        {id:5,name:'user groups',allow:false},
        {id:6,name:'observers',allow:false},
        {id:7,name:'candidates',allow:false},
        {id:8,name:'regions',allow:false},
        {id:9,name:'districts',allow:false},
        {id:10,name:'constituencies',allow:false},
        {id:11,name:'wards',allow:false},
        {id:12,name:'centres',allow:false},
        {id:13,name:'parties',allow:false},
      ]
    },
    PERMISSIONS_TRUE:{
      pages:[
        {id:1,name:'dashboard',name2:'Dashboard Panel',allow:true},
        {id:2,name:'Dashboard Plus',name2:'Other Dashboards',allow:true},
        {id:3,name:'checklist',allow:true},
        {id:4,name:'question list',allow:true},
        {id:5,name:'question configurations',allow:true}, 
        {id:6,name:'reports',allow:true},
        {id:7,name:'observer reports',allow:true}, 
        {id:7,name:'Intervention Desk',allow:true}, 
        {id:7,name:'SMS',allow:true}, 
        {id:8,name:'Results',allow:true}, 
        {id:9,name:'Graph Results',allow:true}, 
        {id:9.1,name:'Map Results',allow:true}, 
        {id:10,name:'Manage Results',allow:true}, 
        {id:11,name:'Settings',allow:true}, 
        {id:12,name:'My Profile',allow:true}, 
        {id:13,name:'Users',allow:true}, 
        {id:14,name:'Candidates',allow:true}, 
        {id:15,name:'Parties',allow:true},
        {id:16,name:'Observers',allow:true}, 
        {id:17,name:'Regions',allow:true},   
        {id:18,name:'Districts',allow:true}, 
        {id:19,name:'Constituencies',allow:true}, 
        {id:20,name:'Wards',allow:true}, 
        {id:21,name:'Centres',allow:true}, 
        {id:22,name:'Permissions',allow:true}, 
      ],
      read:[
        {id:1,name:'results',allow:true},
        {id:2,name:'responses',allow:true},
        {id:3,name:'checklist',allow:true},
        {id:4,name:'users',allow:true},
        {id:5,name:'user groups',allow:true},
        {id:6,name:'observers',allow:true},
        {id:7,name:'candidates',allow:true},
        {id:8,name:'regions',allow:true},
        {id:9,name:'districts',allow:true},
        {id:10,name:'constituencies',allow:true},
        {id:11,name:'wards',allow:true},
        {id:12,name:'centres',allow:true},
        {id:13,name:'parties',allow:true},
      ],
      write:[
        {id:1,name:'results',allow:true},
        {id:2,name:'responses',allow:true},
        {id:3,name:'checklist',allow:true},
        {id:4,name:'users',allow:true},
        {id:5,name:'user groups',allow:true},
        {id:6,name:'observers',allow:true},
        {id:7,name:'candidates',allow:true},
        {id:8,name:'regions',allow:true},
        {id:9,name:'districts',allow:true},
        {id:10,name:'constituencies',allow:true},
        {id:11,name:'wards',allow:true},
        {id:12,name:'centres',allow:true},
        {id:13,name:'parties',allow:true},
      ],
      edit:[
        {id:1,name:'results',allow:true},
        {id:2,name:'responses',allow:true},
        {id:3,name:'checklist',allow:true},
        {id:4,name:'users',allow:true},
        {id:5,name:'user groups',allow:true},
        {id:6,name:'observers',allow:true},
        {id:7,name:'candidates',allow:true},
        {id:8,name:'regions',allow:true},
        {id:9,name:'districts',allow:true},
        {id:10,name:'constituencies',allow:true},
        {id:11,name:'wards',allow:true},
        {id:12,name:'centres',allow:true},
        {id:13,name:'parties',allow:true},
      ],
      delete:[
        {id:1,name:'results',allow:true},
        {id:2,name:'responses',allow:true},
        {id:3,name:'checklist',allow:true},
        {id:4,name:'users',allow:true},
        {id:5,name:'user groups',allow:true},
        {id:6,name:'observers',allow:true},
        {id:7,name:'candidates',allow:true},
        {id:8,name:'regions',allow:true},
        {id:9,name:'districts',allow:true},
        {id:10,name:'constituencies',allow:true},
        {id:11,name:'wards',allow:true},
        {id:12,name:'centres',allow:true},
        {id:13,name:'parties',allow:true},
      ]
    },
    USER_GROUP:null,
    SMS:null
     
  },  
  //___________________-GETTERS-_________________
  getters: {
      getBrowser(){
        return browser
      }, 
      getAppName(state){
        return state.appName
      }, 
      getConnectionState(state) {
        return state.connectionState
      },

      // getUserGroups(state) {
      //   return state.USER_GROUP
      // },
      // getUserGroupByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.USER_GROUP) {return null}
      //     return state.USER_GROUP.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },
      // getPermissions(state) {
      //   return state.PERMISSIONS
      // },
      // getPermissionsTrue(state) {
      //   return state.PERMISSIONS_TRUE
      // },

      
      // getQuestionChecklists(state){
      //   return state.QUESTION_CHECKLISTS
      // },
      // getQuestionChecklistByKey(state){
      //   return key=>{
      //     if (!key) {return null } 
      //     if (!state.QUESTION_CHECKLISTS) {return null}
      //     return state.QUESTION_CHECKLISTS.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionChecklistByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.QUESTION_CHECKLISTS) {return null}
      //     return state.QUESTION_CHECKLISTS.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },
      // getQuestionResponses(state){
      //   return state.QUESTION_RESPONSE
      // },
      // getQuestionResponseByKey(state){
      //   return key=>{
      //     if (!key) {return null }
      //     if (!state.QUESTION_RESPONSE) {return null}
      //     return state.QUESTION_RESPONSE.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionStages(state){
      //   return state.QUESTION_STAGES
      // },
      // getQuestionStageByKey(state){
      //   return key=>{
      //     if (!key) {return null }
      //     if (!state.QUESTION_STAGES) {return null}
      //     return state.QUESTION_STAGES.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionStageByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.QUESTION_STAGES) {return null}
      //     return state.QUESTION_STAGES.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },
      // getQuestionTypes(state){
      //   return state.QUESTION_TYPES
      // },
      // getQuestionTypeByKey(state){
      //   return key=>{
      //     if (!key) {return null }
      //     if (!state.QUESTION_TYPES) {return null}
      //     return state.QUESTION_TYPES.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionTypeByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.QUESTION_TYPES) {return null}
      //     return state.QUESTION_TYPES.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },
      // getQuestionCategories(state){
      //   return state.QUESTION_CATEGORIES
      // },
      // getQuestionCategoryByKey(state){
      //   return key=>{
      //     if (!key) {return null }
      //     if (!state.QUESTION_CATEGORIES) {return null}
      //     return state.QUESTION_CATEGORIES.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionCategoryByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.QUESTION_CATEGORIES) {return null}
      //     return state.QUESTION_CATEGORIES.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },
      // getQuestionTimelines(state){
      //   return state.QUESTION_TIMELINE
      // },
      // getQuestionTimelineByKey(state){
      //   return key=>{
      //     if (!key) {return null }
      //     if (!state.QUESTIONS) {return null}
      //     return state.QUESTIONS.find(it=>{
      //       return it.key == key
      //     })
      //   }
      // },
      // getQuestionTimelineByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.QUESTION_TIMELINE) {return null}
      //     return state.QUESTION_TIMELINE.find(it=>{
      //       return it.code == code
      //     })
      //   }
      // },

      // getGender(state) {
      //   return state.gender
      // }, 
      // getCandidateTypes(state) {
      //   return state.candidateTypes
      // }, 
      
      // getSubmitLevel(state) {
      //   return state.submitLevel
      // }, 

      // getCandidates(state) {
      //   return state.candidates
      // }, 
      // getCandidateByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.candidates) {return null}
      //     return state.candidates.find(pt=>{
      //       return pt.code == code
      //     })
      //   }
      // },
      // getCandidateByPartyCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.candidates) {return null}
      //     return state.candidates.find(pt=>{
      //       return pt.party_code == code
      //     })
      //   }
      // },
      // getParties(state) {
      //   return state.parties
      // }, 
      // getPartyByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.parties) {return null}
      //     return state.parties.find(pt=>{
      //       return pt.code == code
      //     })
      //   }
      // },
      // getRegions(state) {
      //   return state.Regions
      // }, 
      // getRegionByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.Regions) {return null}
      //     return state.Regions.find(rg=>{
      //       return rg.code == code
      //     })
      //   }
      // },
      // getRegionByDistrictCode(state){
      //   return code=>{ 
      //     if (!code) {return null }
      //     if (!state.Regions) {return null}
      //     if (!state.districts) {return null}
      //     let destrict =  state.districts.find(dis=>{
      //       return dis.code == code
      //     })
      //     if (!destrict) {
      //       return null 
      //     }
      //     let region =  state.Regions.find(re=>{
      //       return re.code == destrict.region
      //     })
      //     return region
      //   }
      // },
      // getDistricts(state) {
      //   return state.districts
      // }, 
      // getDistrictByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.districts) {return null}
      //     return state.districts.find(dis=>{
      //       return dis.code == code
      //     })
      //   }
      // },
      // getDistrictByName(state){
      //   return name=>{
      //     if (!name) {return null }
      //     if (!state.districts) {return null}
      //     return state.districts.find(dis=>{
      //       let n1 = dis.name.toUpperCase().replace(/ /g,"")
      //       let n2 = name.toUpperCase().replace(/ /g,"")
      //       return n1 == n2
      //     })
      //   }
      // },
      // getConstituencies(state){
      //   return state.constituencies
      // },
      // getConstituencyByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.constituencies) {return null}
      //     return state.constituencies.find(cons=>{
      //       return cons.code == code
      //     })
      //   }
      // },
      // getConstituencyByName(state){
      //   return name=>{
      //     if (!name) {return null }
      //     if (!state.constituencies) {return null}
      //     return state.constituencies.find(cons=>{
      //       let n1 = cons.name.toUpperCase().replace(/ /g,"")
      //       let n2 = name.toUpperCase().replace(/ /g,"") 
      //       return n1 === n2 
      //     })
      //   }
      // },
      // getWards(state) {
      //   return state.wards
      // },
      // getWardByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.wards) {return null}
      //     return state.wards.find(wd=>{
      //       return wd.code == code
      //     })
      //   }
      // },
      // getWardByName(state){
      //   return name=>{
      //     if (!name) {return null }
      //     if (!state.wards) {return null}
      //     return state.wards.find(wd=>{
      //       let n1 = wd.name.toUpperCase().replace(/ /g,"")
      //       let n2 = name.toUpperCase().replace(/ /g,"")
      //       return n1 == n2  
      //     })
      //   }
      // },
      // getCentres(state) {
      //   return state.centres
      // },
      // getCentreByCode(state){
      //   return code=>{
      //     if (!code) {return null }
      //     if (!state.centres) {return null}
      //     return state.centres.find(wd=>{
      //       return wd.code == code
      //     })
      //   }
      // },
      // getCentreByName(state){
      //   return name=>{
      //     if (!name) {return null }
      //     if (!state.centres) {return null}
      //     return state.centres.find(wd=>{
      //       let n1 = wd.name.toUpperCase().replace(/ /g,"")
      //       let n2 = name.toUpperCase().replace(/ /g,"")
      //       return n1 == n2   
      //     })
      //   }
      // },


      // //DISTRICTS
      // getSubmitResultsLevel(state){
      //   return state.SUBMITTED_RESULTS_LEVEL
      // },
      // getResults(state) {
      //   return type =>{
      //     let results = null
      //     if (type==="district") {
      //       results = state.DISTRICT_RESULTS
      //     }else if (type==="constituency") {
      //       results = state.CONSTITUENCY_RESULTS
      //     }else if (type==="ward") {
      //       results = state.WARD_RESULTS
      //     }else if (type==="centre") {
      //       results = state.CENTRE_RESULTS
      //     } 
      //     return results
      //   } 
      // },
      // getResultByCode(state){
      //   return (code,type)=>{
      //     if (!code) {return null }
      //     if (!type) {return null }
      //     let results = null
      //     if (type==="district") {
      //       results = state.DISTRICT_RESULTS
      //     }else if (type==="constituency") {
      //       results = state.CONSTITUENCY_RESULTS
      //     }else if (type==="ward") {
      //       results = state.WARD_RESULTS
      //     }else if (type==="centre") {
      //       results = state.CENTRE_RESULTS
      //     }  
      //     if (!results) {return null}
      //     return results.find(wd=>{
      //       return wd.code == code
      //     })
      //   }
      // },
      // getResultsDetails(state) {
      //   return type =>{
      //     let resultsDetails = null
      //     if (type==="district") {
      //       resultsDetails = state.DISTRICT_RESULTS_DETAILS
      //     }else if (type==="constituency") {
      //       resultsDetails = state.CONSTITUENCY_RESULTS_DETAILS
      //     }else if (type==="ward") {
      //       resultsDetails = state.WARD_RESULTS_DETAILS
      //     }else if (type==="centre") {
      //       resultsDetails = state.CENTRE_RESULTS_DETAILS
      //     } 
      //     return resultsDetails
      //   } 
      // },
      // getResultsDetailsByKey(state){
      //   return (key,type)=>{
      //     if (!key) {return null }
      //     if (!type) {return null }
      //     let resultsDetails = null
      //     if (type==="district") {
      //       resultsDetails = state.DISTRICT_RESULTS_DETAILS
      //     }else if (type==="constituency") {
      //       resultsDetails = state.CONSTITUENCY_RESULTS_DETAILS
      //     }else if (type==="ward") {
      //       resultsDetails = state.WARD_RESULTS_DETAILS
      //     }else if (type==="centre") {
      //       resultsDetails = state.CENTRE_RESULTS_DETAILS
      //     } 

      //     if (!resultsDetails) {return null}
      //     return resultsDetails.find(wd=>{
      //       return wd.key == key
      //     })
      //   }
      // }, 
      // getSMS(state) {
      //   return state.SMS 
      // },
      // getSMSByKey(state){
      //   return (key)=>{
      //     let sms = state.SMS
      //     if(!sms){return null}
      //     return sms.find(sm=>{
      //       return sm.key == key
      //     })
      //   }
      // }
  },
  //___________________-MUTATIONS-___________________
  mutations:{ 
    updateTitle(state,payload){
      state.appTitle=payload
    },  
    //connection
    updateConnectionState(state,payload){
      state.connectionState = payload
    },
  },
  //____________________-ACTIONS-_____________________
  actions: {
    setConnectionState({ commit }){
      let connRef=firebase.database().ref('.info/connected')
      connRef.on('value',snap=>{ 
        commit('updateConnectionState',snap.val()) 
      })
    }, 
    setTitle({commit},payload){
      commit('updateTitle',payload)
    }, 

    
    //-----------------[ FI ADD]---------------
    // fi_add({ commit}, payload) {
    //   let action = payload.action
    //   let path = payload.path
    //   let data = payload.data
    //   let us = payload.us
    //   let uid = us?us.uid:null

    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'adding/'+action
    //   }) 
    //   if (action) { 
    //     let dt = new Date
    //     let date = dt.toISOString()
    //     let record = {...data,uid:uid,created_at:date}
    //     let ref = firebase.database().ref(path).push(record)
    //     ref.then(res => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'adding/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'adding/'+action+'/successful',
    //         val: res
    //       })
    //     }).catch(err => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'adding/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'adding/'+action+'/error',
    //         val: err
    //       })
    //     })
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'adding/'+action
    //     })
    //     commit('updateResponses', {
    //       res: 'adding/'+action+'/error',
    //       val: "no action"
    //     })
    //   }
    // }, 
    // fi_add_results({ commit}, payload) {
    //   let results = payload.results
    //   let details = payload.details 
    //   let us = payload.us
    //   let uid = us?us.uid:null

    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'adding/results' 
    //   }) 
    //   if (results) { 
    //     let dt = new Date
    //     let date = dt.toISOString()
    //     let record = {...details,uid:uid,created_at:date}
    //     let level = details.level
    //     level = level.charAt(0).toUpperCase() + level.substring(1);
    //     let ref = firebase.database().ref("/RESULTS/"+level+"/ResultsDetails").push(record)
    //     ref.then(res => {
    //       let key = res.key
          
    //       function addResults(){
    //         let resultRef = firebase.database().ref("/RESULTS/"+level+"/Results")
    //         results.forEach(item => {
    //           resultRef.push({...item,results_details_key:key})
    //         });
    //         return resultRef
    //       }
    //       return addResults()
    //     })
    //     .then(res => { 
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'adding/results' 
    //       })
    //       commit('updateResponses', {
    //         res: 'adding/results/successful',
    //         val: res
    //       })
    //     }).catch(err => { 
          
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'adding/results' 
    //       })
    //       commit('updateResponses', {
    //         res: 'adding/results/error',
    //         val: err
    //       })
    //     })
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'adding/results' 
    //     })
    //     commit('updateResponses', {
    //       res: 'adding/results/error',
    //       val: "no action"
    //     })
    //   }
    // }, 
    // fi_add_xl_results({ commit}, payload) {
    //   let xl_results = payload.xl_results
    //   let level = payload.level
    //   let us = payload.us
    //   let uid = us?us.uid:null
       
    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'adding/results' 
    //   }) 

    //   if (xl_results) { 
    //     let dt = new Date
    //     let date = dt.toISOString()
    //     let ref_resultsDetails = null
    //     let ref_results = null

    //     if (level.toUpperCase()==="DISTRICT") {
    //       ref_resultsDetails = firebase.database().ref("/RESULTS/District/ResultsDetails")
    //       ref_results = firebase.database().ref("/RESULTS/District/Results")
    //     }else if (level.toUpperCase()==="CONSTITUENCY") {
    //       ref_resultsDetails = firebase.database().ref("/RESULTS/Constituency/ResultsDetails")
    //       ref_results = firebase.database().ref("/RESULTS/Constituency/Results")
    //     }else if (level.toUpperCase()==="WARD") {
    //       ref_resultsDetails = firebase.database().ref("/RESULTS/Ward/ResultsDetails")
    //       ref_results = firebase.database().ref("/RESULTS/Ward/Results")
    //     }else if (level.toUpperCase()==="CENTRE") {
    //       ref_resultsDetails = firebase.database().ref("/RESULTS/Centre/ResultsDetails")
    //       ref_results = firebase.database().ref("/RESULTS/Centre/Results")
    //     }

    //     function addResults(results,key){
    //       let record = []
    //       results.forEach(item => {
    //         record.push({...item,results_details_key:key}) 
    //       }); 
    //       ref_results.push(record)
    //       return ref_results
    //     }
    //     function addResultsDetails(){ 
    //       let results_record = []
    //       let results_size = xl_results.length
    //       let results_number = 0
    //       xl_results.forEach(resultsDetails => { 
            
    //         //calculate Results detail
    //         let details = {
    //           region_code:resultsDetails.district.region_code,
    //           district_code:resultsDetails.district.code,
    //           constituency_code:resultsDetails.constituency?resultsDetails.constituency.code:"",
    //           ward_code:resultsDetails.ward?resultsDetails.ward.code:"",
    //           centre_code:resultsDetails.centre?resultsDetails.centre.code:"",
    //           tracking_key:resultsDetails.tracking_key,
    //           form_type:resultsDetails.form_type,
    //           user_type:"admin"
    //         }
    //         let record = {...details,uid:uid,created_at:date}

    //         //calculate Results
    //         let candidates_results = resultsDetails.results
    //         let results = []
    //         candidates_results.forEach(element => {
    //           results.push({
    //             candidate_code:element.candidate_code,
    //             level:element.level,
    //             votes:element.votes
    //           })
    //         });  
  
    //         //push
    //         ref_resultsDetails.push(record) 
    //         .then(res => {
    //           let key = res.key   
    //           results.forEach(item => {
    //             results_record.push({...item,results_details_key:key}) 
    //           }); 
    //           results_number = results_number+1
    //           return results_number
    //         })
    //         .then(number=>{ 
    //           if (number === results_size) {
    //             ref_results.set(results_record)
    //           } 
    //         })
    //         .catch(err => { 
    //           //not 
    //           console.log(err, "error");
              
    //           commit('updateLoading', false)
    //           commit('updateProcesses', { 
    //             name: 'adding/results' 
    //           })
    //           commit('updateResponses', {
    //             res: 'adding/results/error',
    //             val: err
    //           })
    //         })
    //       });   
    //     }

    //     if (ref_resultsDetails) {
    //       ref_resultsDetails.set(null)
    //       .then(res=>{
    //         return ref_results.set(null)
    //       })
    //       .then(res=>{
    //         return addResultsDetails()
    //       }) 
    //       .then(res => { 
    //         //not
    //         commit('updateLoading', false)
    //         commit('updateProcesses', { 
    //           name: 'adding/results' 
    //         })
    //         commit('updateResponses', {
    //           res: 'adding/results/successful',
    //           val: res
    //         })
    //       }).catch(err => { 
    //         //not 
    //         console.log(err, "error");
            
    //         commit('updateLoading', false)
    //         commit('updateProcesses', { 
    //           name: 'adding/results' 
    //         })
    //         commit('updateResponses', {
    //           res: 'adding/results/error',
    //           val: err
    //         })
    //       })
    //     } else {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'adding/results' 
    //       })
    //       commit('updateResponses', {
    //         res: 'adding/results/error',
    //         val: "no action"
    //       })
    //     }
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'adding/results' 
    //     })
    //     commit('updateResponses', {
    //       res: 'adding/results/error',
    //       val: "no action"
    //     })
    //   }
    // }, 

    // //-----------------[ FI UPDATE]---------------
    // fi_update({ commit}, payload) {
    //   let action = payload.action
    //   let path = payload.path
    //   let data = payload.data
    //   let us = payload.us
    //   let uid = us?us.uid:null

    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'updating/'+action
    //   }) 
    //   if (action) { 
    //     let dt = new Date
    //     let date = dt.toISOString()
    //     let record = {...data,uid:uid,updated_at:date}
    //     let ref = firebase.database().ref(path).update(record)
    //     ref.then(res => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'updating/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'updating/'+action+'/successful',
    //         val: res
    //       })
    //     }).catch(err => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'updating/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'updating/'+action+'/error',
    //         val: err
    //       })
    //     })
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'updating/'+action
    //     })
    //     commit('updateResponses', {
    //       res: 'updating/'+action+'/error',
    //       val: "no action"
    //     })
    //   }
    // }, 

    // //-----------------[ FI set]-------------- 
    // fi_set({ commit}, payload) {
    //   let action = payload.action
    //   let path = payload.path
    //   let data = payload.data
    //   let us = payload.us
    //   let uid = us?us.uid:null
    //   let array = payload.array

    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'setting/'+action
    //   }) 
    //   if (action) { 
    //     let dt = new Date
    //     let date = dt.toISOString()
    //     let record =array?data:{...data,uid:uid,update:date}
    //     let ref = firebase.database().ref(path).set(record)
    //     ref.then(res => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'setting/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'setting/'+action+'/successful',
    //         val: res
    //       })
    //     }).catch(err => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'setting/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'setting/'+action+'/error',
    //         val: err
    //       })
    //     })
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'setting/'+action
    //     })
    //     commit('updateResponses', {
    //       res: 'setting/'+action+'/error',
    //       val: "no action"
    //     })
    //   }
    // },

    // //-----------------[ FI DELETE]------------
    // fi_delete({ commit}, payload) {
    //   let action = payload.action
    //   let path = payload.path  

    //   //not
    //   commit('updateLoading', true)
    //   commit('updateProcesses', {
    //     add: true,
    //     name: 'deleting/'+action
    //   }) 
    //   if (action) {  
    //     let ref = firebase.database().ref(path).set(null)
    //     ref.then(res => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'deleting/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'deleting/'+action+'/successful',
    //         val: res
    //       })
    //     }).catch(err => {
    //       //not
    //       commit('updateLoading', false)
    //       commit('updateProcesses', { 
    //         name: 'deleting/'+action
    //       })
    //       commit('updateResponses', {
    //         res: 'deleting/'+action+'/error',
    //         val: err
    //       })
    //     })
    //   } else {
    //     //not
    //     commit('updateLoading', false)
    //     commit('updateProcesses', { 
    //       name: 'deleting/'+action
    //     })
    //     commit('updateResponses', {
    //       res: 'deleting/'+action+'/error',
    //       val: "no action"
    //     })
    //   }
    // }, 
   
    //-----------------[ FI GET ]--------------\ 
    fi_getOn_question_checklists({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionChecklists'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Checklists')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionChecklists'
        })
        let obj = data.val()
        let questionChecklist = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionChecklist.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_CHECKLISTS = questionChecklist

      })
    },
    fi_getOn_question_responses({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionResponses'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Responses')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionResponses'
        })
        let obj = data.val()
        let questionResponse = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionResponse.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_RESPONSE = questionResponse

      })
    },
    fi_getOn_question_stages({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionStages'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Stages/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionStages'
        })
        let obj = data.val()
        let questionStages = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionStages.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_STAGES = questionStages

      })
    },
    fi_getOn_question_categories({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionCategories'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Categories')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionCategories'
        })
        let obj = data.val()
        let questionCategories = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionCategories.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_CATEGORIES = questionCategories

      })
    },
    fi_getOn_question_types({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionTypes'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Types')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionTypes'
        })
        let obj = data.val()
        let questionTypes = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionTypes.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_TYPES = questionTypes

      })
    },
    fi_getOn_question_timelines({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/questionTimeline'
      }) 
      let ref = firebase.database().ref('/QUESTIONS/Timelines')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/questionTimeline'
        })
        let obj = data.val()
        let questionTimeline = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          questionTimeline.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.QUESTION_TIMELINE = questionTimeline

      })
    },

    fi_getOn_candidates({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/candidates'
      }) 
      let ref = firebase.database().ref('/Candidates/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/candidates'
        })
        let obj = data.val()
        let candidates = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          candidates.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.candidates = candidates

      })
    },
    fi_getOn_parties({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/parties'
      }) 
      let ref = firebase.database().ref('/Parties/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/parties'
        })
        let obj = data.val()
        let parties = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          parties.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.parties = parties

      })
    },
    fi_getOn_regions({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/Regions'
      })
      let ref = firebase.database().ref('/Regions/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/Regions'
        })
        let obj = data.val()
        let Regions = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          Regions.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.Regions = Regions

      })
    },
    fi_getOn_districts({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/districts'
      })
      let ref = firebase.database().ref('/Districts/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/districts'
        })
        let obj = data.val()
        let districts = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          districts.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.districts = districts

      })
    },
    fi_getOn_constituencies({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/constituencies'
      })
      let ref = firebase.database().ref('/Constituencies/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/constituencies'
        })
        let obj = data.val()
        let constituencies = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          constituencies.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.constituencies = constituencies

      })
    },
    fi_getOn_wards({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/wards'
      })
      let ref = firebase.database().ref('/Wards/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/wards'
        })
        let obj = data.val()
        let wards = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          wards.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.wards = wards

      })
    },
    fi_getOn_centres({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/centres'
      })
      let ref = firebase.database().ref('/Centres/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/centres'
        })
        let obj = data.val()
        let centres = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          centres.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.centres = centres  
      })
    },

    //SUBMITTED LEVEL
    fi_getOn_submitted_results_level({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/results/level'
      })
      let ref = firebase.database().ref('/RESULTS/Level/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/results/level'
        })
        let obj = data.val() 
        state.SUBMITTED_RESULTS_LEVEL = obj  
      })
    },
    //DISTRICTS
    fi_getOn_district_results({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/results/district'
      })
      let ref = firebase.database().ref('/RESULTS/District/Results/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/results/district'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.DISTRICT_RESULTS = results  
      })
    },
    fi_getOn_district_results_details({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/resultsDetailts/district'
      })
      let ref = firebase.database().ref('/RESULTS/District/ResultsDetails/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/resultsDetailts/district'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.DISTRICT_RESULTS_DETAILS = results  
      })
    },
    //CONSTITUENCY
    fi_getOn_constituency_results({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/results/constituency'
      })
      let ref = firebase.database().ref('/RESULTS/Constituency/Results/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/results/constituency'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.CONSTITUENCY_RESULTS = results  
      })
    },
    fi_getOn_constituency_results_details({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/resultsDetails/constituency'
      })
      let ref = firebase.database().ref('/RESULTS/Constituency/ResultsDetails/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/resultsDetails/constituency'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.CONSTITUENCY_RESULTS_DETAILS = results  
      })
    },
    //WARDS
    fi_getOn_ward_results({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/results/ward'
      })
      let ref = firebase.database().ref('/RESULTS/Ward/Results/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/results/ward'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.WARD_RESULTS = results  
      })
    },
    fi_getOn_ward_results_details({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/resultsDetails/ward'
      })
      let ref = firebase.database().ref('/RESULTS/Ward/ResultsDetails/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/resultsDetails/ward'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.WARD_RESULTS_DETAILS = results  
      })
    },
    //CENTRES
    fi_getOn_centre_results({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/results/centre'
      })
      let ref = firebase.database().ref('/RESULTS/Centre/Results/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/results/centre'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.CENTRE_RESULTS = results  
      })
    },
    fi_getOn_centre_results_details({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/resultsDetails/centre'
      })
      let ref = firebase.database().ref('/RESULTS/Centre/ResultsDetails/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/resultsDetails/centre'
        })
        let obj = data.val()
        let results = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          results.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.CENTRE_RESULTS_DETAILS = results  
      })
    },


    fi_getOn_user_group({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/userGroups'
      })
      let ref = firebase.database().ref('/SETTINGS/USER_GROUPS/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/userGroups'
        })
        let obj = data.val()
        let userGroups = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          userGroups.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.USER_GROUP = userGroups  
      })
    },
    fi_getOn_SMS({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/SMS'
      })
      let ref = firebase.database().ref('/SMS/MS2021/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/SMS'
        })
        let obj = data.val()
        let SMS = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          let message = sms?sms.message:null
          let sms_split = message?message.split(' '):null
          let district = sms_split?sms_split[0]:null
          let district_code = district?district*1:0
          district_code = district_code?district_code:0
          
          let question = sms_split?sms_split[1]:null
          let question_number = question?question*1:0
          question_number = question_number?question_number:0 
          SMS.push({
            i:i,
            key: key,
            ...sms,
            district_code:district_code,
            question_number:question_number
          })
          i++
        } 
        state.SMS = SMS  
      })
    },
     
  },
}